import { LLMClassifierLibraryResponse } from "models/LLMs";
import { BaseService } from "./BaseService";

class LLMClassifierLibraryService extends BaseService {
    protected urlBase = "api/LLMClassifierLibrary";

    public async getLLMClassifierLibrary(
        abortSignal?: AbortSignal,
    ): Promise<LLMClassifierLibraryResponse> {
        return this.get<LLMClassifierLibraryResponse>(
            new URLSearchParams(),
            "",
            abortSignal,
        );
    }

    public async addToLibrary(
        llmClassifierId: string,
    ): Promise<{ message: string }> {
        const apiPath = "AddToLibrary";
        return this.post("", new URLSearchParams({ llmClassifierId }), apiPath);
    }

    public async removeFromLibrary(
        llmClassifierId: string,
    ): Promise<{ message: string }> {
        const apiPath = "RemoveFromLibrary";
        return this.post("", new URLSearchParams({ llmClassifierId }), apiPath);
    }

    public async addFromLibrary(coreLlmClassifierId: string): Promise<void> {
        const apiPath = "AddFromLibrary";
        return this.post(
            "",
            new URLSearchParams({ coreLlmClassifierId }),
            apiPath,
        );
    }

    public async addFromLibraryGroup(
        coreClassifierGroupId: string,
        includeChildGroups = false,
    ): Promise<void> {
        const apiPath = "AddFromLibraryGroup";
        return this.post(
            "",
            new URLSearchParams({
                coreClassifierGroupId,
                includeChildGroups: String(includeChildGroups),
            }),
            apiPath,
        );
    }

    public async updateFromLibrary(
        tenantClassifierId: string,
        libraryClassifierId: string,
        versionDescription: string,
    ): Promise<void> {
        const apiPath = "UpdateFromLibrary";
        return this.post(
            "",
            new URLSearchParams({
                tenantClassifierId,
                libraryClassifierId,
                versionDescription,
            }),
            apiPath,
        );
    }
}

export default LLMClassifierLibraryService;
